module.exports = __webpack_public_path__ + "static/opportunities-ea641a3483d3329bfb7bcd6119501530.svg";